import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
  FiSearch,
  FiFile,
  FiChevronLeft,
  FiChevronRight,
} from 'react-icons/fi';

import { FormHandles } from '@unform/core';
import {
  FaYoutube,
  FaTrophy,
  FaFilePdf,
  FaFileExcel,
  FaFilePowerpoint,
} from 'react-icons/fa';
import { userInfo } from 'os';
import { Link, useParams } from 'react-router-dom';
import { AiOutlineReload } from 'react-icons/ai';
import { uuid } from 'uuidv4';
import Button from '../Button';
import { useAuth } from '../../hooks/Auth';
import { useModal } from '../../hooks/Modal';
import { useToast } from '../../hooks/Toast';
import CreateModule from '../SearchComponent/modules/Create';
import { Sponsors } from '../../pages/Home/styles';

import { useSocket } from '../../hooks/Socket';

import QuizzComponent from '../QuizzComponent';

import {
  Form,
  Input,
  Container,
  Sidebar,
  Body,
  Header,
  Content,
  AnimatedContainer,
  VideoContainer,
  HeaderBox,
  SidebarMobileButton,
  Modal,
} from './styles';
import SidebarContent from './Sidebar';
import HeaderContent from './Header';
import api from '../../services/api';
import { useVideo } from '../../hooks/Video';
import Vimeo from '../Vimeo';
import WebsitePopupComponent from '../WebsitePopupComponent';
import ChatRoom from '../ChatRoom';
import Youtube from '../Youtube';
import { urlWebsite } from '../../config';
import Program from '../Program';
import { RoomMessagerContainer, RoomMessagerCreator } from '../RoomMessager';
import { RoomChangeContainer, RoomChangeCreator } from '../RoomChange';

interface IValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface IvideoIdItem {
  videoIdItem: string;
}

interface IValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<IValidationRules>;
}

interface IUploads {
  document: string;
  title?: string;
  id?: number;
  user_name?: string;
}

interface IUploadFile {
  title: string;
  type: 'PDF' | 'PPT' | 'XLS';
  url: string;
}

const ClassRoomContainer: React.FC = () => {
  const {
    courses,
    setCoursesList,
    videoStatus,
    openVideo,
    setFilter,
    openVideoByID,
    openCategory,
  } = useVideo();

  const { socket } = useSocket();

  const { user, signOut, token } = useAuth();
  const [loading, setLoading] = useState(true);
  const [eventDay, setEventDay] = useState(true);
  const [online, setOnline] = useState(true);
  const formRef = useRef<FormHandles>(null);
  const [activeMenu, setActiveMenu] = useState(false);
  const [programActive, setProgramActive] = useState(false);
  const { addToast } = useToast();
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploads, setUploads] = useState<Array<IUploads>>([]);
  const [chatKey, setChatKey] = useState(() => new Date().getMilliseconds());

  const [allowQuizz, setAllowQuizz] = useState(true);

  const { addModal } = useModal();
  const [playerKey, setPlayerKey] = useState('videoPlayer');

  const { videoIdItem } = useParams<IvideoIdItem>();
  const load = async () => {
    setLoading(true);
    const response = await api.get('/my-courses');
    const { data } = response;

    if (!data || data.length < 1) {
      setLoading(false);
      setOnline(false);
    } else {
      setLoading(false);
      setCoursesList(data || []);
      setOnline(true);
      if (videoIdItem) {
        openVideoByID(data || [], parseInt(videoIdItem));
      }
    }
  };

  const reloadChat = () => {
    setChatKey(new Date().getMilliseconds());
  };

  const reloadPlayer = () => {
    const d = new Date();
    const n = d.getTime();
    setPlayerKey(`video${n}`);
  };

  useEffect(() => {
    reloadChat();
    load();
    socket.on('disconnectUser', () => {
      console.log('disconnect me');
      addToast({
        type: 'error',
        title: 'Você foi desconectado',
        description: 'Seu toke expirou ou outra pessoa logou com o seu acesso.',
      });
      setTimeout(() => {
        signOut();
        window.location.href = '/';
      }, 3000);
    });

    socket.on('checkDisconnectUser', state => {
      console.log('check disconnect me', state);
      if (token !== state.token) {
        addToast({
          type: 'error',
          title: 'Você foi desconectado',
          description:
            'Seu toke expirou ou outra pessoa logou com o seu acesso.',
        });
        setTimeout(() => {
          signOut();
          window.location.href = '/';
        }, 3000);
      }
    });
    socket.emit('checkUser');
  }, []);

  useEffect(() => {
    reloadChat();
    load();
    setProgramActive(false);
  }, [videoIdItem]);

  const handleSearch = (data: Record<string, any>): void => {
    setFilter(data.search || '');
  };

  const FormVideo: React.FC = () => {
    const handleNewVideo = (data: Record<string, any>) => {};
    const endpoint = '/lessons-simple';

    const formSchema = {
      title: {
        model: 'input',
        name: 'title',
        label: 'Título',
        defaultValue: '',
      },

      video_type_id: {
        alias: 'video_type',
        model: 'selectApi',
        name: 'video_type_id',
        label: 'Tipo de Vídeo',
        defaultValue: 1,
        endpoint,
      },
      video_id: {
        model: 'input',
        name: 'video_id',
        label: 'Código do Vídeo',
        defaultValue: '',
      },
    };

    const validationSchema: Record<string, IValidationSchema> = {
      title: {
        name: 'title',
        type: 'string',
        label: 'Título',
        rules: [{ type: 'required' }],
      },
      video_id: {
        name: 'video_id',
        type: 'string',
        label: 'Código do Vìdeo',
        rules: [{ type: 'required' }],
      },
    };

    return (
      <CreateModule
        title="Adicionar Vídeo"
        formSchema={formSchema}
        validationSchema={validationSchema}
        endpoint={endpoint}
        buttonContent={(
          <div
            style={{
              color: 'red',
              fontSize: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <FaYoutube />
          </div>
        )}
        addCallback={load}
      />
    );
  };

  const ListRoom = () => {
    return (
      (videoStatus &&
        videoStatus.type === 'list' &&
        courses[videoStatus.course] &&
        courses[videoStatus.course].lessons.map((lesson, index) => (
          <AnimatedContainer
            key={`videoLesson${lesson.id}`}
            className="videoBox"
            onClick={() => openVideo(courses, videoStatus.course, index)}
          >
            {lesson.image && (
              <>
                <img
                  style={{ width: '100%', cursor: 'pointer' }}
                  src={`${urlWebsite}/${lesson.image}`}
                  title={lesson.title}
                  alt={lesson.title}
                />
                <p
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    position: 'absolute',
                    bottom: '30px',
                    padding: '0 10px',
                    fontSize: '13px',
                    fontWeight: 600,
                  }}
                />
              </>
            )}

            {!lesson.image && lesson.title && (
              <div
                style={{
                  background: '#026271',
                  color: '#fff',
                  padding: '20px',
                  minHeight: '250px',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <h2>{lesson.title}</h2>
              </div>
            )}
          </AnimatedContainer>
        ))) || <></>
    );
  };

  const OpenRoom = () => {
    const validTypes = {
      PDF: <FaFilePdf />,
      XLSX: <FaFileExcel />,
      PPT: <FaFilePowerpoint />,
    };

    const uploadFiles: Array<IUploadFile> =
      videoStatus &&
      videoStatus.type === 'video' &&
      courses[videoStatus.course] &&
      courses[videoStatus.course].lessons &&
      courses[videoStatus.course].lessons[videoStatus.video] &&
      courses[videoStatus.course].lessons[videoStatus.video].uploads
        ? courses[videoStatus.course].lessons[videoStatus.video].uploads || []
        : [];

    return (
      (videoStatus &&
        videoStatus.type === 'video' &&
        courses[videoStatus.course] &&
        courses[videoStatus.course].lessons &&
        courses[videoStatus.course].lessons[videoStatus.video] && (
          <>
            <div className="videoGroup">
              <VideoContainer>
                <h2 style={{ width: '100%', textAlign: 'center' }}>
                  {courses[videoStatus.course].lessons[videoStatus.video].title}
                </h2>

                <RoomMessagerContainer
                  room_id={
                    courses &&
                    courses[videoStatus.course] &&
                    courses[videoStatus.course].lessons &&
                    courses[videoStatus.course].lessons[videoStatus.video]
                      ? courses[videoStatus.course].lessons[videoStatus.video]
                          .id
                      : 0
                  }
                  module_id={1}
                />
                {!eventDay && (
                  <HeaderBox>
                    {videoStatus.prevVideo ? (
                      <button
                        className="defaultButton"
                        type="button"
                        onClick={() => {
                          videoStatus.prevVideo &&
                            openVideo(
                              courses,
                              videoStatus.prevVideo.courseIndex,
                              videoStatus.prevVideo.videoIndex,
                            );
                        }}
                      >
                        <FiChevronLeft />
                        Anterior
                      </button>
                    ) : (
                      <button type="button" className="defaultButton" />
                    )}
                    <button
                      onClick={() => openCategory(0, 0)}
                      type="button"
                      className="defaultButton"
                    >
                      Menu
                    </button>
                    <button
                      onClick={() => setProgramActive(true)}
                      className="defaultButton"
                      type="button"
                    >
                      Programação
                    </button>
                    {videoStatus.nextVideo ? (
                      <button
                        className="defaultButton"
                        type="button"
                        onClick={() => {
                          videoStatus.nextVideo &&
                            openVideo(
                              courses,
                              videoStatus.nextVideo.courseIndex,
                              videoStatus.nextVideo.videoIndex,
                            );
                        }}
                      >
                        Próximo
                        <FiChevronRight />
                      </button>
                    ) : (
                      <button type="button" className="defaultButton" />
                    )}
                  </HeaderBox>
                )}
                {user && user.profile !== 9 && (
                  <>
                    <div className="videoContainer">
                      {courses[videoStatus.course].lessons[videoStatus.video]
                        .video_type === 2 ||
                      courses[videoStatus.course].lessons[videoStatus.video]
                        .video_type_id === 2 ? (
                          <Vimeo
                          keyName={playerKey}
                          id={
                            courses[videoStatus.course].lessons[
                              videoStatus.video
                            ].video_id
                          }
                        />
                      ) : (
                        <Youtube
                          keyName={playerKey}
                          id={
                            courses[videoStatus.course].lessons[
                              videoStatus.video
                            ].video_id
                          }
                        />
                      )}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexWrap: 'wrap',
                        }}
                      >
                        <button
                          style={{ margin: '10px', background: '#fff' }}
                          title="Player not working? Click here!"
                          className="reloadPlayer"
                          onClick={() => reloadPlayer()}
                        >
                          <AiOutlineReload />
{' '}
Recarregar vídeo
</button>
                      </div>
                    </div>
                  </>
                )}
              </VideoContainer>
              <div style={{ position: 'relative' }}>
                <QuizzComponent
                  roomNumber={
                    courses[videoStatus.course].lessons[videoStatus.video].id
                  }
                />

                <ChatRoom
                  id={courses[videoStatus.course].lessons[videoStatus.video].id}
                />

                {user && user.profile === 1 && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      padding: '5px',
                    }}
                  >
                    <WebsitePopupComponent
                      roomNumber={
                        courses &&
                        courses[videoStatus.course] &&
                        courses[videoStatus.course].lessons &&
                        courses[videoStatus.course].lessons[videoStatus.video]
                          ? courses[videoStatus.course].lessons[
                              videoStatus.video
                            ].id
                          : 0
                      }
                    />
                    <RoomChangeCreator
                      room_id={
                        courses &&
                        courses[videoStatus.course] &&
                        courses[videoStatus.course].lessons &&
                        courses[videoStatus.course].lessons[videoStatus.video]
                          ? courses[videoStatus.course].lessons[
                              videoStatus.video
                            ].id
                          : 0
                      }
                      module_id={1}
                    />
                  </div>
                )}

                {user &&
                  (user.profile === 1 ||
                    user.profile === 4 ||
                    user.profile === 6) && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '5px',
                      }}
                    >
                      <RoomMessagerCreator
                        room_id={
                          courses &&
                          courses[videoStatus.course] &&
                          courses[videoStatus.course].lessons &&
                          courses[videoStatus.course].lessons[videoStatus.video]
                            ? courses[videoStatus.course].lessons[
                                videoStatus.video
                              ].id
                            : 0
                        }
                        module_id={1}
                      />
                    </div>
                  )}
              </div>
            </div>
          </>
        )) || <></>
    );
  };

  const showTrophy = () => {
    addToast({
      type: 'info',
      title: 'Nenhum troféu identificado',
      description: 'Continue sua jornada para alcançar novas conquistas',
    });
  };

  if (loading) {
    return <Container />;
  }

  return (
    <Container>
      <Content>
        {eventDay && videoStatus.type === 'list' && (
          <Sidebar active={activeMenu}>
            <SidebarContent courses={courses} />
          </Sidebar>
        )}
        <Body>
          {eventDay ? (
            <>
              {ListRoom()}
              {OpenRoom()}
            </>
          ) : (
            <div className="onlineMessage">
              <img src="/assets/evento/logo.png" alt="Imagem" />
              <h2 style={{ color: '#fff' }}>Inscrição Confirmada</h2>
              <p style={{ color: '#fff' }}>
                O evento estará disponível a partir das 17h30.
              </p>
              <Link to="/">
                <button className="defaultButton" type="button">
                  {' '}
                  Sair
                </button>
              </Link>
            </div>
          )}
        </Body>
      </Content>

      {programActive && (
        <Modal top right>
          <div
            style={{
              display: 'block',
            }}
          >
            <button type="button" onClick={() => setProgramActive(false)}>
              Fechar
{' '}
            </button>

            <Program />
          </div>
        </Modal>
      )}
      <RoomChangeContainer />
    </Container>
  );
};

export default ClassRoomContainer;
